import { TemplateData, TemplateParams } from '.';

const calendarEventAccessRequestAccept = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventAccessRequestAccept}
        ${messages.calendarEventAccessEventPage}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventAddedToEvent}`
  },
  placeholders: {
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    startDate: {
      label: messages.commonStartDate,
      example: '27.3.2024'
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Welcome to the event.'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventAccessRequestAccept
});

export default calendarEventAccessRequestAccept;
